import script from "./SetFromRoute.vue?vue&type=script&lang=js"
export * from "./SetFromRoute.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__